import { useLayoutEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';

import useTheme from 'hooks/useTheme';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

const ThemeProvider: FunctionComponent<Props> = ({ testId = TEST_ID, value }) => {
    const { context } = useTheme();

    const [theme, setTheme] = useState(value);

    useLayoutEffect(() => {
        import(`./../../../styles/themes/${theme}/theme.scss`);
    }, [theme]);

    return (
        <context.Provider data-testid={testId} value={{ setTheme, theme }}>
            <Outlet />
        </context.Provider>
    );
};

ThemeProvider.displayName = 'ThemeProvider';

export default ThemeProvider;
